import { COUNTRIES, isUnitedStates } from '@/utils/countries';
import { selectOptions } from '@/utils/select-options';
import { US_STATE_CODES } from '@/utils/us-states';

export { isUnitedStates };

/** Countries whose addresses don't have a postal/zip code. */
export const IGNORE_COUNTRY_ZIPCODE = ['curaçao'];

/** Prompt for an unset country `<Select>`, passed as its `placeholder`. */
export const COUNTRY_PLACEHOLDER = 'Select a country';

/** Prompt for an unset US state `<Select>`, passed as its `placeholder`. */
export const US_STATE_PLACEHOLDER = 'US state';

/** Country options for an address `<Select>`. */
export const COUNTRY_SELECT_OPTIONS = selectOptions(COUNTRIES);

/** US state options for an address `<Select>`. */
export const US_STATE_SELECT_OPTIONS = selectOptions(US_STATE_CODES);

/** Whether the country's addresses have no postal/zip code (so the field is ignored). */
export function isZipCodeIgnored(country: string): boolean {
  return IGNORE_COUNTRY_ZIPCODE.includes(country.toLowerCase());
}
